import { ParticipationOption } from '../types/participation.types';

export const participationOptions: ParticipationOption[] = [
  // Espacios verdes
  { id: 'ev1', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev1' },
  { id: 'ev2', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev2' },
  { id: 'ev3', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev3' },

  // Stands exteriores
  { id: 'exA', name: 'STANDS EXTERIORES A', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exA' },
  { id: 'exB', name: 'STANDS EXTERIORES B', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exB' },
  { id: 'exC', name: 'STANDS EXTERIORES C', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exC' },

  // Food trucks
  { id: 'food', name: 'SECTOR FOOD TRUCKS', category: 'food', available: false, isSelectable: false, className: 'food' },

  // Fila 1 - Stands naranjas (1-8)
  ...Array.from({ length: 8 }, (_, i) => ({
    id: `${i + 1}`,
    name: `Stand ${i + 1}`,
    category: 'orange' as const,
    price: 2500,
    size: '7.50m²',
    available: true,
    isSelectable: true,
    className: 'fila1-item'
  })),

  // Salas
  { id: 'sala1', name: 'SALA 1', category: 'sala', available: false, isSelectable: false, className: 'sala1' },
  { id: 'sala2', name: 'SALA 2', category: 'sala', available: false, isSelectable: false, className: 'sala2' },

  // Plazas
  { id: 'plaza-auto1', name: 'PLAZA AUTOMOTRIZ', category: 'plaza', price: 5000, size: '50m²', available: true, isSelectable: true, className: 'plaza-auto1' },
  { id: 'plaza-auto2', name: 'PLAZA AUTOMOTRIZ', category: 'plaza', price: 5000, size: '50m²', available: true, isSelectable: true, className: 'plaza-auto2' },
  { id: 'plaza-innovacion', name: 'PLAZA DE LA INNOVACIÓN', category: 'plaza', price: 8000, size: '180m²', available: true, isSelectable: true, className: 'plaza-innovacion' },

  // Stands individuales
  { id: '9', name: 'Stand 9', category: 'celeste', price: 4000, size: '21.60m²', available: true, isSelectable: true, className: 'stand9' },
  { id: '20', name: 'Stand 20', category: 'pink', price: 3500, size: '18m²', available: true, isSelectable: true, className: 'stand20' },
  { id: '23', name: 'Stand 23', category: 'celeste', price: 4000, size: '21.60m²', available: true, isSelectable: true, className: 'stand23' },
  { id: '34', name: 'Stand 34', category: 'pink', price: 3500, size: '18m²', available: true, isSelectable: true, className: 'stand34' },

  // Bloques rojos (10-18 y 24-32)
  ...Array.from({ length: 9 }, (_, i) => {
    const standNum = i < 8 ? i + 10 : i + 11;
    const isFirstBlock = i < 8;
    return {
      id: `${standNum}`,
      name: `Stand ${standNum}`,
      category: 'red' as const,
      price: 2800,
      size: '7.80m²',
      available: true,
      isSelectable: true,
      className: isFirstBlock ? 'bloque-rojo1-item' : 'bloque-rojo2-item'
    };
  }),

  // Fila 3 - Stands naranjas (35-42)
  ...Array.from({ length: 8 }, (_, i) => ({
    id: `${i + 35}`,
    name: `Stand ${i + 35}`,
    category: 'orange' as const,
    price: 2500,
    size: '7.50m²',
    available: true,
    isSelectable: true,
    className: 'fila3-item'
  })),

  // Sala principal
  { id: 'sala-principal', name: 'SALA PRINCIPAL', category: 'principal', available: false, isSelectable: false, className: 'sala-principal' },

  // Sala VIP
  { id: 'sala-vip', name: 'SALA VIP', category: 'vip', available: false, isSelectable: false, className: 'sala-vip' }
];

// Opciones de cargo organizadas por tipo de organización
export const opcionesPorTipoOrganizacion = {
  'Empresa / PyME': {
    cargos: [
      'Director General (CEO)',
      'Presidente',
      'Vicepresidente',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Apoderado',
      'Asistente',
      'Otro'
    ]
  },
  'Startup / Emprendimiento': {
    cargos: [
      'Fundador',
      'Cofundador',
      'Director General (CEO)',
      'Presidente',
      'Miembro del Directorio / Advisory',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Agencia / Consultora': {
    cargos: [
      'Socio Director',
      'Director General',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Productor Ejecutivo',
      'Asesor',
      'Representante Comercial',
      'Asistente',
      'Otro'
    ]
  },
  'Cámara Empresarial / Sectorial': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante Sectorial',
      'Asistente',
      'Otro'
    ]
  },
  'Cámara de Comercio Binacional': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante País/Región',
      'Asistente',
      'Otro'
    ]
  },
  'Asociación Profesional': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante Institucional',
      'Asistente',
      'Otro'
    ]
  },
  'ONG / Fundación / Asociación Civil': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario',
      'Tesorero',
      'Director Ejecutivo',
      'Miembro del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Responsable de Proyectos',
      'Asistente',
      'Otro'
    ]
  },
  'Universidad / Institución Educativa': {
    cargos: [
      'Rector',
      'Vicerrector',
      'Secretario General',
      'Decano',
      'Vicedecano',
      'Director de Instituto/Escuela',
      'Director de Área',
      'Profesor Titular',
      'Investigador Principal',
      'Coordinador',
      'Asistente',
      'Otro'
    ]
  },
  'Centro Tecnológico / I+D': {
    cargos: [
      'Director General',
      'Vicedirector',
      'Secretario',
      'Miembro del Consejo Académico',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Investigador Principal',
      'Investigador Responsable',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Institución de Salud / Deportiva / Cultural / Turismo / Otra': {
    cargos: [
      'Director General',
      'Vicedirector',
      'Secretario',
      'Miembro del Consejo Directivo',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Responsable de Programas',
      'Asistente',
      'Otro'
    ]
  },
  'Gobierno Nacional / Provincial': {
    cargos: [
      'Ministro',
      'Secretario',
      'Subsecretario',
      'Jefe de Gabinete',
      'Titular de Organismo/Agencia',
      'Director Nacional/Provincial',
      'Director General',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Gobierno Municipal': {
    cargos: [
      'Intendente/Alcalde',
      'Jefe de Gabinete',
      'Secretario',
      'Subsecretario',
      'Director General',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Concejal',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Ente o Institución del Sector Público': {
    cargos: [
      'Presidente del Ente',
      'Vicepresidente',
      'Director Ejecutivo',
      'Gerente General',
      'Director General',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Interventor',
      'Asistente',
      'Otro'
    ]
  },
  'Organismo Internacional': {
    cargos: [
      'Representante Residente',
      'Director de País',
      'Jefe de Misión',
      'Oficial Superior',
      'Director Ejecutivo',
      'Miembro del Board',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Enlace',
      'Asistente',
      'Otro'
    ]
  },
  'Embajada': {
    cargos: [
      'Embajador',
      'Ministro Consejero (Jefe de Misión Adjunto)',
      'Consejero',
      'Primer Secretario',
      'Segundo Secretario',
      'Agregado',
      'Cónsul General',
      'Cónsul',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Inversionista / Aceleradora': {
    cargos: [
      'Socio Director',
      'Director General',
      'Miembro del Directorio',
      'Partner',
      'Managing Partner',
      'Director de Inversiones',
      'Gerente de Área',
      'Coordinador',
      'Asesor',
      'Analista de Inversiones',
      'Asistente',
      'Otro'
    ]
  },
  'Medio de Comunicación': {
    cargos: [
      'Director General',
      'Director',
      'Editor General',
      'Productor Ejecutivo',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Proveedor de Soluciones Tecnológicas': {
    cargos: [
      'Director General (CEO)',
      'Presidente',
      'Vicepresidente',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Apoderado',
      'Asistente',
      'Otro'
    ]
  }
};

// Mantener las listas originales para compatibilidad (se pueden eliminar más adelante)
export const cargos = [
  'CEO/Director General',
  'Gerente',
  'Coordinador',
  'Analista',
  'Desarrollador',
  'Diseñador',
  'Marketing',
  'Ventas',
  'Recursos Humanos',
  'Otro'
];

export const areas = [
  'Dirección y Gobierno Corporativo',
  'Administración y Finanzas',
  'Recursos Humanos / Talento',
  'Operaciones',
  'Tecnología e Innovación',
  'Marketing, Comunicación y Ventas',
  'Desarrollo de Negocios y Estrategia',
  'Productos y Servicios',
  'Sostenibilidad y Responsabilidad Social',
  'Seguridad, Riesgo y Cumplimiento',
  'Asuntos Públicos y Relacionamiento Externo'
];

// Subáreas organizadas por área
export const subareasPorArea = {
  'Dirección y Gobierno Corporativo': {
    subareas: [
      'Dirección General / CEO',
      'Presidencia',
      'Vicepresidencia',
      'Secretaría de Directorio',
      'Gobierno Corporativo',
      'Auditoría Interna',
      'Gestión de Riesgos',
      'Asuntos Legales / Jurídicos',
      'Compliance y Ética',
      'Relaciones Institucionales'
    ]
  },
  'Administración y Finanzas': {
    subareas: [
      'Administración General',
      'Contabilidad',
      'Finanzas',
      'Control de Gestión',
      'Tesorería',
      'Impuestos',
      'Compras y Contrataciones',
      'Gestión de Proveedores',
      'Auditoría Financiera',
      'Presupuesto y Planeamiento'
    ]
  },
  'Recursos Humanos / Talento': {
    subareas: [
      'Desarrollo de Talento',
      'Selección y Reclutamiento',
      'Capacitación y Formación',
      'Evaluaciones de Desempeño',
      'Compensaciones y Beneficios',
      'Cultura Organizacional',
      'Diversidad, Equidad e Inclusión',
      'Relaciones Laborales',
      'Clima Organizacional',
      'Bienestar y Salud Ocupacional'
    ]
  },
  'Operaciones': {
    subareas: [
      'Operaciones Generales',
      'Logística',
      'Supply Chain',
      'Gestión de Calidad',
      'Gestión de Procesos',
      'Mantenimiento',
      'Servicios Generales',
      'Producción / Planta',
      'Seguridad e Higiene',
      'Operaciones Técnicas'
    ]
  },
  'Tecnología e Innovación': {
    subareas: [
      'Sistemas / TI',
      'Infraestructura Tecnológica',
      'Desarrollo de Software',
      'Soporte Técnico',
      'Ciberseguridad',
      'Arquitectura de Datos',
      'Big Data & Analytics',
      'Inteligencia Artificial',
      'Innovación y Transformación Digital',
      'Automatización y Robótica',
      'UX/UI y Productos Digitales'
    ]
  },
  'Marketing, Comunicación y Ventas': {
    subareas: [
      'Marketing',
      'Comunicación Institucional',
      'Comunicación Interna',
      'Branding',
      'Publicidad',
      'Ventas',
      'Atención al Cliente',
      'Experiencia de Usuario / Customer Success',
      'Relaciones Públicas',
      'Eventos Corporativos',
      'Investigación de Mercados',
      'Marketing Digital & Performance'
    ]
  },
  'Desarrollo de Negocios y Estrategia': {
    subareas: [
      'Planeamiento Estratégico',
      'Nuevos Negocios',
      'Desarrollo Corporativo',
      'Innovación Empresarial',
      'Alianzas y Partnerships',
      'Gestión de Proyectos',
      'Inteligencia Competitiva',
      'Expansión Internacional'
    ]
  },
  'Productos y Servicios': {
    subareas: [
      'Gestión de Producto',
      'Desarrollo de Servicios',
      'Investigación & Desarrollo (I+D)',
      'Laboratorios',
      'Gestión de Portafolio',
      'Experiencia del Usuario'
    ]
  },
  'Sostenibilidad y Responsabilidad Social': {
    subareas: [
      'Sostenibilidad Ambiental',
      'Economía Circular',
      'Energía y Transición Verde',
      'Responsabilidad Social Empresaria (RSE)',
      'Gestión de Impacto',
      'Reportes ESG'
    ]
  },
  'Seguridad, Riesgo y Cumplimiento': {
    subareas: [
      'Seguridad Física',
      'Seguridad Informática',
      'Gestión de Riesgos',
      'Crisis y Continuidad Operativa',
      'Compliance',
      'Asuntos Regulatorios'
    ]
  },
  'Asuntos Públicos y Relacionamiento Externo': {
    subareas: [
      'Relaciones Gubernamentales',
      'Relaciones con la Comunidad',
      'Vinculación Académica',
      'Relaciones Internacionales',
      'Gestión de Stakeholders'
    ]
  }
};

export const tiposOrganizacion = [
  'Empresa / PyME',
  'Startup / Emprendimiento',
  'Agencia / Consultora',
  'Cámara Empresarial / Sectorial',
  'Cámara de Comercio Binacional',
  'Asociación Profesional',
  'ONG / Fundación / Asociación Civil',
  'Universidad / Institución Educativa',
  'Centro Tecnológico / I+D',
  'Institución de Salud / Deportiva / Cultural / Turismo / Otra',
  'Gobierno Nacional / Provincial',
  'Gobierno Municipal',
  'Ente o Institución del Sector Público',
  'Organismo Internacional',
  'Embajada',
  'Inversionista / Aceleradora',
  'Medio de Comunicación',
  'Proveedor de Soluciones Tecnológicas'
];

export const organizaciones = [
  'Google', 'Microsoft', 'Apple', 'Amazon', 'Meta (Facebook)', 'Tesla', 'Netflix', 'Spotify',
  'Uber', 'Airbnb', 'Salesforce', 'Adobe', 'Oracle', 'IBM', 'Intel', 'Cisco', 'Dell', 'HP',
  'NVIDIA', 'AMD', 'Samsung', 'Sony', 'Panasonic', 'LG', 'Huawei', 'Xiaomi', 'Alibaba',
  'Tencent', 'Baidu', 'ByteDance', 'OpenAI', 'Anthropic', 'Stripe', 'Square', 'PayPal',
  'Visa', 'Mastercard', 'American Express', 'JPMorgan Chase', 'Bank of America', 'Wells Fargo',
  'Goldman Sachs', 'Morgan Stanley', 'BlackRock', 'Vanguard', 'Berkshire Hathaway',
  'Johnson & Johnson', 'Procter & Gamble', 'Coca-Cola', 'PepsiCo', 'Nestlé', 'Unilever',
  'General Electric', 'General Motors', 'Ford', 'Toyota', 'Volkswagen', 'BMW', 'Mercedes-Benz',
  'Audi', 'Honda', 'Nissan', 'Hyundai', 'Kia', 'Ferrari', 'Porsche', 'Lamborghini'
];

export const industrias = [
  'Agroindustria, Producción de Alimentos y Bioeconomía',
  'Alimentación, Nutrición y Sistemas Alimentarios Urbanos',
  'Agua, Saneamiento y Recursos Hídricos',
  'Energía, Recursos Naturales y Transición Energética',
  'Construcción, Infraestructura y Desarrollo Urbano',
  'Arquitectura, Diseño Urbano y Construcción Sostenible',
  'Movilidad, Transporte y Logística Inteligente',
  'Tecnología, Innovación y Transformación Digital',
  'Inteligencia Artificial y Tecnologías Avanzadas',
  'Ciberseguridad y Protección de Datos',
  'Electrónica, Automatización y Robótica',
  'Manufactura, Industria 4.0 y Producción Avanzada',
  'Minería, Materiales y Recursos Naturales',
  'Economía Circular y Gestión de Residuos',
  'Medio Ambiente y Cambio Climático',
  'Salud, Medicina y Ciencias de la Vida',
  'Deporte, Ciencias del Deporte y Bienestar',
  'Educación, Formación y EdTech',
  'Cultura, Industrias Creativas y Economía Naranja',
  'Turismo, Hotelería y Gastronomía',
  'Comercio, Retail y Comercio Electrónico',
  'Finanzas, Banca, Seguros y Fintech',
  'Telecomunicaciones y Conectividad',
  'Economía Social, Cooperativas y Desarrollo Comunitario',
  'Gobierno, Políticas Públicas y Smart Governance',
  'Seguridad, Emergencias y Resiliencia Urbana',
  'Inmobiliario, Real Estate y PropTech',
  'Recursos Humanos, Talento y Desarrollo Profesional',
  'Legal, Contable y Servicios Profesionales',
  'Industrias Textil, Moda y Sostenibilidad',
  'Industria Farmacéutica y Laboratorios',
  'Nanotecnología y Ciencia de Materiales',
  'Aeronáutica, Aeroespacial y Drones',
  'Servicios Empresariales y Consultoría',
  'Industrias Creativas Digitales y Medios'
];

// Subindustrias organizadas por industria
export const subindustriasPorIndustria = {
  'Agroindustria, Producción de Alimentos y Bioeconomía': {
    subindustrias: [
      'AgTech',
      'Ganadería',
      'Producción Agroalimentaria',
      'Bioinsumos',
      'Trazabilidad'
    ]
  },
  'Alimentación, Nutrición y Sistemas Alimentarios Urbanos': {
    subindustrias: [
      'Foodtech',
      'Nutrición',
      'Seguridad Alimentaria',
      'Cadenas de Valor Alimentarias'
    ]
  },
  'Agua, Saneamiento y Recursos Hídricos': {
    subindustrias: [
      'Tratamiento de Agua',
      'Saneamiento',
      'Infraestructura Hídrica',
      'Monitoreo'
    ]
  },
  'Energía, Recursos Naturales y Transición Energética': {
    subindustrias: [
      'Energías Renovables',
      'Oil & Gas',
      'Redes Inteligentes',
      'Almacenamiento Energético'
    ]
  },
  'Construcción, Infraestructura y Desarrollo Urbano': {
    subindustrias: [
      'Obras Públicas',
      'Construcción Privada',
      'Materiales',
      'Infraestructura Urbana'
    ]
  },
  'Arquitectura, Diseño Urbano y Construcción Sostenible': {
    subindustrias: [
      'Diseño Urbano',
      'Arquitectura Sustentable',
      'Certificaciones Ambientales'
    ]
  },
  'Movilidad, Transporte y Logística Inteligente': {
    subindustrias: [
      'Movilidad Eléctrica',
      'Transporte Público',
      'ITS',
      'Logistica 4.0'
    ]
  },
  'Tecnología, Innovación y Transformación Digital': {
    subindustrias: [
      'Cloud',
      'IoT',
      'Software',
      'Hardware'
    ]
  },
  'Inteligencia Artificial y Tecnologías Avanzadas': {
    subindustrias: [
      'AI',
      'Machine Learning',
      'Deep Learning',
      'Automatización Inteligente'
    ]
  },
  'Ciberseguridad y Protección de Datos': {
    subindustrias: [
      'Ciberseguridad',
      'Gestión de Identidad',
      'Protección de Datos'
    ]
  },
  'Electrónica, Automatización y Robótica': {
    subindustrias: [
      'Robótica',
      'Automatización Industrial',
      'Sensores'
    ]
  },
  'Manufactura, Industria 4.0 y Producción Avanzada': {
    subindustrias: [
      'Fábricas Inteligentes',
      'Impresión 3D',
      'Ingeniería de Procesos'
    ]
  },
  'Minería, Materiales y Recursos Naturales': {
    subindustrias: [
      'Minería Sostenible',
      'Procesamiento de Minerales',
      'Nuevos Materiales'
    ]
  },
  'Economía Circular y Gestión de Residuos': {
    subindustrias: [
      'Reciclaje',
      'Gestión de Residuos',
      'Valorización'
    ]
  },
  'Medio Ambiente y Cambio Climático': {
    subindustrias: [
      'Mitigación',
      'Adaptación',
      'Monitoreo Ambiental'
    ]
  },
  'Salud, Medicina y Ciencias de la Vida': {
    subindustrias: [
      'Hospitales',
      'Salud Digital',
      'Biotech',
      'Equipamiento Médico'
    ]
  },
  'Deporte, Ciencias del Deporte y Bienestar': {
    subindustrias: [
      'Clubes',
      'Fitness',
      'eSports',
      'Tecnología Deportiva'
    ]
  },
  'Educación, Formación y EdTech': {
    subindustrias: [
      'Instituciones Educativas',
      'EdTech',
      'Capacitación'
    ]
  },
  'Cultura, Industrias Creativas y Economía Naranja': {
    subindustrias: [
      'Audiovisual',
      'Videojuegos',
      'Música',
      'Diseño'
    ]
  },
  'Turismo, Hotelería y Gastronomía': {
    subindustrias: [
      'Hotelería',
      'Gastronomía',
      'Turismo Inteligente'
    ]
  },
  'Comercio, Retail y Comercio Electrónico': {
    subindustrias: [
      'RetailTech',
      'E-commerce',
      'Centros Comerciales'
    ]
  },
  'Finanzas, Banca, Seguros y Fintech': {
    subindustrias: [
      'Fintech',
      'Seguros',
      'Banca Digital'
    ]
  },
  'Telecomunicaciones y Conectividad': {
    subindustrias: [
      '5G',
      'Fibra Óptica',
      'Satélites',
      'Proveedores de Internet'
    ]
  },
  'Economía Social, Cooperativas y Desarrollo Comunitario': {
    subindustrias: [
      'Cooperativas',
      'ONGs',
      'Desarrollo Social'
    ]
  },
  'Gobierno, Políticas Públicas y Smart Governance': {
    subindustrias: [
      'Gobierno Digital',
      'Datos Abiertos',
      'Servicios Públicos'
    ]
  },
  'Seguridad, Emergencias y Resiliencia Urbana': {
    subindustrias: [
      'Seguridad Ciudadana',
      'Bomberos',
      'Emergencias Médicas',
      'Defensa Civil'
    ]
  },
  'Inmobiliario, Real Estate y PropTech': {
    subindustrias: [
      'Desarrollos Inmobiliarios',
      'PropTech',
      'Gestión de Activos'
    ]
  },
  'Recursos Humanos, Talento y Desarrollo Profesional': {
    subindustrias: [
      'Consultoras RRHH',
      'Capacitación Ejecutiva',
      'Reclutamiento'
    ]
  },
  'Legal, Contable y Servicios Profesionales': {
    subindustrias: [
      'Estudios Jurídicos',
      'Estudios Contables',
      'Asesorias'
    ]
  },
  'Industrias Textil, Moda y Sostenibilidad': {
    subindustrias: [
      'Moda Sostenible',
      'Producción Textil',
      'Innovación Textil'
    ]
  },
  'Industria Farmacéutica y Laboratorios': {
    subindustrias: [
      'Laboratorios',
      'Investigación Clínica',
      'Desarrollo Farmacéutico'
    ]
  },
  'Nanotecnología y Ciencia de Materiales': {
    subindustrias: [
      'Nanomateriales',
      'Laboratorios',
      'Aplicaciones Industriales'
    ]
  },
  'Aeronáutica, Aeroespacial y Drones': {
    subindustrias: [
      'Drones',
      'Aeronáutica',
      'Aeroespacial'
    ]
  },
  'Servicios Empresariales y Consultoría': {
    subindustrias: [
      'Consultorías',
      'Auditoría',
      'Servicios BPO'
    ]
  },
  'Industrias Creativas Digitales y Medios': {
    subindustrias: [
      'Agencias Digitales',
      'Medios',
      'Publicidad'
    ]
  }
};

// Opciones del catálogo
export const opcionesCatalogo = [
  'Sección "Empresas que brindan soluciones y tecnologías"',
  'Sección "Empresas con impacto"',
  'Sección "Gobiernos que Innovan"'
];

// Opciones del programa del evento
export const opcionesPrograma = [
  'Participar como SPEAKER en una sesión oficial del Congreso',
  'Organizar un EVENTO PARALELO (workshop, mesa redonda, demo, presentación sectorial, entre otros)',
  'Disponer de un STAND en la zona expo (soluciones, instituciones, empresas, gobiernos o proyectos)',
  'Realizar acciones de COMUNICACIÓN y presencia de marca (activaciones especiales, señalética, copatrocinios)',
  'Integrar rondas de negocios y networking sectorial',
  'Disponer de pases a eventos institucionales de vinculación'
];

// Mantener objetivos para compatibilidad (ya no se usa)
export const objetivos = [];

export const ejesInteres = [
  'Gobernanza, Planificación y Gestión Pública',
  'Transformación Digital, Inteligencia Artificial y Nuevas Tecnologías',
  'Ciberseguridad, Confianza Digital y Protección de Datos',
  'Movilidad, Transporte y Logística Inteligente',
  'Economía del Conocimiento, Innovación Productiva y Emprendimiento',
  'Energía y Recursos Naturales',
  'Construcción, Infraestructura y Desarrollo Urbano',
  'Ambiente, Agua, Residuos y Sustentabilidad Productiva',
  'Seguridad Ciudadana, Prevención, Emergencias y Respuesta',
  'Salud, Bienestar y Calidad de Vida',
  'Deporte, Ciencias del Deporte e Integración Comunitaria',
  'Alimentación, Agro, Producción de Alimentos y Bioeconomía',
  'Educación, Talento, Empleo y Nuevas Profesiones',
  'Ciencia, Investigación, Tecnología y Transferencia (I+D)',
  'Cultura, Turismo, Patrimonio, Medios y Economía Creativa'
];

// Subejes organizados por eje de interés
export const subejesPorEje = {
  'Gobernanza, Planificación y Gestión Pública': {
    subejes: [
      'Gobierno abierto',
      'Planificación estratégica',
      'Modernización del Estado',
      'Datos, indicadores y evidencias',
      'Participación ciudadana',
      'Gestión territorial'
    ]
  },
  'Transformación Digital, Inteligencia Artificial y Nuevas Tecnologías': {
    subejes: [
      'IA aplicada a gobiernos, empresas y comunidades',
      'IoT y sistemas conectados',
      'Ciencia de datos',
      'Automatización y robótica',
      'Cloud y edge computing',
      'Identidad digital',
      'Tecnologías emergentes'
    ]
  },
  'Ciberseguridad, Confianza Digital y Protección de Datos': {
    subejes: [
      'Ciberseguridad pública y privada',
      'Infraestructuras críticas',
      'Privacidad',
      'Gestión de riesgos digitales',
      'Normativas y estándares',
      'Resiliencia digital'
    ]
  },
  'Movilidad, Transporte y Logística Inteligente': {
    subejes: [
      'Movilidad urbana',
      'Transporte público y privado',
      'Infraestructura vial',
      'Seguridad vial',
      'Logística, última milla y cadenas de suministro',
      'Movilidad sostenible'
    ]
  },
  'Economía del Conocimiento, Innovación Productiva y Emprendimiento': {
    subejes: [
      'Startups',
      'Innovación abierta',
      'Industria 4.0',
      'Transformación de cadenas productivas',
      'Nuevos modelos de negocio',
      'Parques tecnológicos y clusters'
    ]
  },
  'Energía y Recursos Naturales': {
    subejes: [
      'Energía renovable y no renovable',
      'Hidrógeno, biocombustibles',
      'Redes inteligentes',
      'Minería, litio, recursos estratégicos',
      'Energía para la industria',
      'Eficiencia energética'
    ]
  },
  'Construcción, Infraestructura y Desarrollo Urbano': {
    subejes: [
      'Desarrollo urbano',
      'Vivienda y hábitat',
      'Construcción inteligente',
      'Arquitectura y diseño urbano',
      'Infraestructura territorial',
      'Espacio público'
    ]
  },
  'Ambiente, Agua, Residuos y Sustentabilidad Productiva': {
    subejes: [
      'Gestión del agua',
      'Gestión integral de residuos',
      'Economía circular',
      'Biodiversidad',
      'Cambio climático y resiliencia',
      'Suelo y producción sostenible'
    ]
  },
  'Seguridad Ciudadana, Prevención, Emergencias y Respuesta': {
    subejes: [
      'Seguridad ciudadana',
      'Videovigilancia y tecnología aplicada',
      'Fuerzas de seguridad',
      'Bomberos',
      'Salud prehospitalaria / SAME',
      'Gestión del riesgo',
      'Protección civil y emergencias'
    ]
  },
  'Salud, Bienestar y Calidad de Vida': {
    subejes: [
      'Salud digital',
      'Atención primaria',
      'Infraestructura sanitaria',
      'Sistemas de cuidado',
      'Prevención y estilos de vida',
      'Salud mental y bienestar'
    ]
  },
  'Deporte, Ciencias del Deporte e Integración Comunitaria': {
    subejes: [
      'Fútbol y todos los deportes',
      'Infraestructura deportiva',
      'Actividad física y salud',
      'Ciencias del deporte',
      'Industria del deporte',
      'Formación y empleo deportivo',
      'Deporte como integración comunitaria'
    ]
  },
  'Alimentación, Agro, Producción de Alimentos y Bioeconomía': {
    subejes: [
      'Agro y agroindustrias',
      'Tecnología en alimentos',
      'Nutrición y seguridad alimentaria',
      'Bioeconomía',
      'Producción sostenible',
      'Cadenas agroproductivas'
    ]
  },
  'Educación, Talento, Empleo y Nuevas Profesiones': {
    subejes: [
      'Educación formal y no formal',
      'Universidades, institutos',
      'Empleo y desarrollo de talento',
      'Formación técnica',
      'Nuevas profesiones',
      'Capacitación continua'
    ]
  },
  'Ciencia, Investigación, Tecnología y Transferencia (I+D)': {
    subejes: [
      'Centros de investigación',
      'Laboratorios',
      'Ciencia aplicada',
      'DeepTech',
      'Vinculación tecnológica',
      'Innovación científica'
    ]
  },
  'Cultura, Turismo, Patrimonio, Medios y Economía Creativa': {
    subejes: [
      'Industrias creativas',
      'Turismo y destinos',
      'Patrimonio cultural',
      'Medios de comunicación',
      'Producción audiovisual',
      'Eventos y economía cultural'
    ]
  }
};